import axios from "axios";

const API_URL = process.env.NEXT_PUBLIC_BACKEND_URL;

export const getVideos = async (page = 1, category = "aiw", pageSize = 9, sortType = 'publish_date', sort = 'desc') => {
  return await axios.get(
    `${API_URL}/videos/filter?page=${page}&category=${category}&sortType=${sortType}&sort=${sort}&pageSize=${pageSize}`
  );
};

//https://api.researchfrc.com/api/videos/filter?sort=desc&sort=desc&page=1&category=eci&sortType=desc&pageSize=publish_date

export const getVideo = async (title) => {
  return await axios.post(`${API_URL}/videos/find`, {
    title,
  });
};

export default async function getAIW(currentPage, pageSize, sort = "desc") {
  const params = new URLSearchParams({
    sort: sort,
    page: currentPage,
    pageSize: pageSize,
  });

  if (!pageSize) params.delete("pageSize");

  // Append the query parameters to the URL
  const url = new URL(`${API_URL}/posts/analyst-ideas`);
  url.search = params.toString();


  const response = await fetch(url, {
    cache: "no-store", // Use the cache by default
    next: { tags: [""] },
    headers: {
      Accept: "application/json",
    },
  });

  const data = await response.json();


  return data;
}

export const getPrivateCompanyReports = async (currentPage = 1, pageSize = 3, sort = 'desc', token, companyName) => {

  const params = new URLSearchParams({
    sort: sort,
    page: currentPage,
    pageSize: pageSize,
  });

  if (!pageSize) params.delete("pageSize");

  const url = new URL(`${API_URL}/private-companies/reports/${companyName}`);
  url.search = params.toString();

  try {
    const response = await fetch(url, {
      cache: "no-store",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok && response.status === 404) {
      // Handle 404 without throwing an error
      return {
        success: false,
        message: "No reports available for this company.",
      };
    }

    const data = await response.json();
    
    return data;
  } catch (error) {
    throw error;
  }
}

export const getResearchReports = async (
  currentPage,
  pageSize,
  sort,
  search = "",
  ticker = ""
) => {
  const params = new URLSearchParams({
    sort: sort,
    page: currentPage,
    pageSize: pageSize,
    search: search,
    ticker: ticker,
  });

  if (!pageSize) params.delete("pageSize");
  if (!search) params.delete("search");
  if (!ticker) params.delete("ticker");

  const url = new URL(`${API_URL}/posts/research-reports`);
  url.search = params.toString();

  try {
    const response = await fetch(url, {
      cache: "no-store",
      headers: {
        Accept: "application/json",
      },
    });

    if (!response.ok && response.status === 404) {
      // Handle 404 without throwing an error
      return {
        success: false,
        message: "No reports available for this company.",
      };
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching reports: ", error);
    throw error; // Rethrow the error for further handling if needed
  }
};

export const getResearchReport = async (postId) => {
  const response = await axios.get(
    `${API_URL}/posts/research-reports/${postId}`,
    {
      cache: "force-cache", // Use the cache by default
      next: {
        revalidate: 600, // Revalidate every 10min (600 seconds)
      },
      headers: {
        Accept: "application/json",
      },
    }
  );

  return response;
};

export const getSingleAIW = async (postId) => {
  const response = await axios.get(`${API_URL}/posts/analyst-ideas/${postId}`, {
    cache: "no-cache", // Use the cache by default
    next: {
      revalidate: 600, // Revalidate every 10min (600 seconds)
    },
    headers: {
      Accept: "application/json",
    },
  });

  return response;
};

export const getPressReleases = async (
  currentPage,
  ticker,
  sort,
  pageSize = 2
) => {
  try {
    const params = new URLSearchParams({
      page: currentPage,
      ticker: ticker,
      sort: sort,
      pageSize: pageSize,
    });

    if (!pageSize) params.delete("pageSize");

    const response = await axios.get(`${API_URL}/press-release/filter`, {
      params,
      headers: {
        Accept: "application/json",
      },
    });

    return response; // Assuming the response data is what you're interested in
  } catch (error) {
    // Optionally, rethrow the error or handle it as needed
    return [];
  }
};

export const getOldResearchReports = async (
  currentPage,
  pageSize,
  sort,
  ticker = "",
  isCompanyPrivate = false,
  companyId = ""
) => {

  let params;
  
  if(isCompanyPrivate) {
     params = new URLSearchParams({
      sort: sort,
      page: currentPage,
      pageSize: pageSize,
      company: companyId,
      private: isCompanyPrivate,
    });
  }
  else{
    params = new URLSearchParams({
      sort: sort,
      page: currentPage,
      pageSize: pageSize,
      ticker: ticker,
      private: isCompanyPrivate,
    });
  }

  if (!pageSize) params.delete("pageSize");
  if (!ticker) params.delete("ticker");

  const response = await axios.get(`${API_URL}/posts/old-reports`, {
    cache: "no-cache", // Use the cache by default
    params, // Use the params object directly
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
  return response;
};

export const getOldPrivateCompanyResearchReports = async (
  currentPage,
  pageSize,
  sort,
  ticker,
  isCompanyPrivate = false
) => {
  const params = new URLSearchParams({
    sort: sort,
    page: currentPage,
    pageSize: pageSize,
    private: isCompanyPrivate,
  });

  if (!pageSize) params.delete("pageSize");
  if (!ticker) params.delete("ticker");

  const response = await axios.get(`${API_URL}/private-companies/old-reports/${companyId}`, {
    cache: "no-cache", // Use the cache by default
    params, // Use the params object directly
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });



  return response;
};

export const toggleLike = async (token, postId) => {
  return await axios.post(
    `${API_URL}/posts/like`,
    {
      post_id: postId,
    },
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    }
  );
};


